import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { DEFAULT_PAGE_NUMBER, DEFAULT_LOAD_MORE } from '../../../../constants';
import { clientTransactionsRoute } from '../route';

import { getClientTransactionHistoryFilterFormSchema } from './components/ClientTransactionHistoryFilter/helpers/getClientTransactionHistoryFilterFormSchema';

const clientTransactionHistoryFilterFormSchema =
	getClientTransactionHistoryFilterFormSchema();

export const clientTransactionsHistoryRoute = createRoute({
	path: '/history',
	getParentRoute: () => clientTransactionsRoute,
	component: lazyRouteComponent(
		() => import('./ClientTransactionHistoryPage'),
		'ClientTransactionHistoryPage',
	),
	validateSearch: z.object({
		openedTransaction: z.string().optional(),
		pageNumber: z.number().prefault(DEFAULT_PAGE_NUMBER),
		loadMore: z.number().prefault(DEFAULT_LOAD_MORE),
		historyFilter: clientTransactionHistoryFilterFormSchema.catch({
			directions: [],
			paymentGroups: [],
			transactionStatus: [],
		}),
	}),
});
